import stringHelper from "./string";
import IBGEHelper from "./IBGE";

function buildPhysicalRequestBody(payload) {
  return {
    data: {
      attributes: payload.physical,
      relationships: buildRelationships(payload)
    }
  };
}

function buildLegalRequestBody(payload) {
  return {
    data: {
      attributes: payload.legal,
      relationships: {
        ...buildRelationships(payload),
        ...buildLegalRepresentativeRelationship(payload)
      }
    }
  };
}

function buildRelationships(payload) {
  return {
    account: {
      attributes: buildAccountAttributes(payload.account)
    },
    profile: {
      attributes: buildProfileAttributes(payload)
    },
    phones: {
      attributes: buildPhonesAttributes(payload.phones)
    }
  };
}

function buildAccountAttributes(account) {
  return {
    email: account.email.toLowerCase(),
    first_name: stringHelper.capitalize(account.first_name),
    last_name: stringHelper.capitalize(account.last_name),
    password: account.password,
    password_confirmation: account.password_confirmation
  };
}

function buildProfileAttributes(payload) {
  const { profile, profile_picture } = payload;

  let res = {
    state_name: getState(profile.state),
    city_name: getCity(profile.city),
    birthdate: profile.birthdate
  };

  if (profile_picture) res["profile_picture"] = profile_picture;

  return res;
}

function buildPhonesAttributes(payload) {
  let phones = [];
  payload.forEach(phone => {
    let phoneObj = buildPhone(phone);
    phones.push(phoneObj);
  });
  return phones;
}

function buildPhone(phone) {
  return {
    country_code: "55",
    area_code: phone.substr(0, 2),
    number: phone.substr(2, phone.length)
  };
}

function buildLegalRepresentativeRelationship(payload) {
  let address = payload.legal_representative_address;

  return {
    legal_representative: {
      attributes: {
        first_name: stringHelper.capitalize(payload.account.first_name),
        last_name: stringHelper.capitalize(payload.account.last_name),
        cpf: payload.legal_representative.cpf,
        birthdate: payload.legal_representative.birthdate,
        address: {
          street: address.street,
          street_number: address.street_number,
          complement: address.complement,
          district: stringHelper.capitalize(address.district),
          city: getCity(address.city),
          state: getState(address.state),
          country: address.country.toUpperCase(),
          zip_code: address.zip_code
        },
        phone: buildPhone(payload.legal_representative.phone)
      }
    }
  };
}

const getCity = city => {
  let res = typeof city === "string" ? city : IBGEHelper.getCityName(city);
  return stringHelper.capitalize(res);
};
const getState = state => {
  let res =
    typeof state === "string" ? state : IBGEHelper.getStateInitials(state);
  return res.toUpperCase();
};

export default {
  buildPhysicalRequestBody,
  buildLegalRequestBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/accountable.js